import { ToastContainer } from '@palmetto/palmetto-components';
import classNames from 'classnames';
import React from 'react';

import { getCoreConfig } from '../../config/config';
import Content from './components/Content';
import styles from './Page.module.scss';

type PageLayout = 'grid' | 'singleItem' | 'blank';

export interface PageProps {
  className?: string;
  layout: PageLayout;
  headingLine1?: string;
  headingLine2?: string;
  children: React.ReactNode;
  title?: string;
  leftContent?: React.ReactNode;
  rightContent?: React.ReactNode;
  onRetry?: () => void;
  intercomSlot?: React.ReactNode;
  bannerSlot?: React.ReactNode;
  hasError?: boolean;
  errorSlot?: React.ReactNode;
  contentRef?: React.RefObject<HTMLDivElement>;
  disableContentBottomPadding?: boolean;
}

export const Page: React.FC<PageProps> = (props) => {
  const {
    className,
    layout,
    headingLine1,
    headingLine2,
    children,
    onRetry,
    intercomSlot,
    bannerSlot,
    hasError = false,
    errorSlot,
    contentRef: externalContentRef,
    disableContentBottomPadding,
  } = props;

  const isChromatic = getCoreConfig().isChromatic;

  const internalContentRef = React.useRef<HTMLDivElement>(null);
  const contentRef = externalContentRef ?? internalContentRef;

  return (
    <>
      {bannerSlot}
      {intercomSlot}
      <ToastContainer position="bottom-center" />
      <Content
        ref={contentRef}
        className={classNames(styles.content, {
          [styles.staticContent]: isChromatic,
          [styles.blank]: layout === 'blank',
        })}
        staticContent={isChromatic}
        disableBottomPadding={disableContentBottomPadding}
      >
        <div className={classNames(styles.contentContainer, styles[layout])}>
          {hasError ? (
            errorSlot ?? null
          ) : (
            <>
              {headingLine1 && (
                <h1 className={classNames(styles.heading, 'body-500')}>
                  {headingLine1}
                  {headingLine2 && <br />}
                  {headingLine2}
                </h1>
              )}
              <div className={classNames(styles.body, className, styles[layout])}>{children}</div>
            </>
          )}
        </div>
      </Content>
    </>
  );
};

export default Page;
